import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=2de4aa93&"
import script from "../../models/points/setting.ts?vue&type=script&lang=ts&"
export * from "../../models/points/setting.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports